var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('StandardComponent',{attrs:{"id":_vm.id,"injectionID":_vm.iid},on:{"update:injectionID":_vm.updatedInjectionID,"update:standardData":_vm.updatedStandardData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }